import React from "react";
import InputAdornment from "@mui/material/InputAdornment";
import TextInput from "../ui/TextInput";
import ViewSelectDropdown from "./ViewSelectDropdown";

const VIEWS = [
  { value: "album", label: "Albums" },
  { value: "artist", label: "Artists" },
  { value: "track", label: "Tracks" },
];

export default function CatalogSearch({
  view,
  onViewChange,
  value,
  onChange,
  autoFocus,
}) {
  const label =
    VIEWS.find((option) => option.value === view)?.label || "Albums";
  return (
    <TextInput
      className="album-search catalog-search"
      fullWidth
      autoFocus={autoFocus}
      type="text"
      aria-label={`Search ${label.toLowerCase()}`}
      placeholder="Search..."
      value={value}
      onChange={onChange}
      endAdornment={
        <InputAdornment position="end">
          <ViewSelectDropdown
            value={view}
            options={VIEWS}
            onChange={onViewChange}
          />
        </InputAdornment>
      }
    />
  );
}
